import { companyService } from "src/services/api";

const state = {
  status: {},
  errors: [],
  statusText: "",
  single: {},
};

const actions = {
  async update({ dispatch, commit }, payload) {
    await companyService.update(payload).then(
      () => {
        commit("setSingle", payload);
      },
      (error) => {
        commit("setFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async updatePayment({ dispatch, commit }, payload) {
    await companyService.updatePayment(payload).then(
      (response) => {
        console.log(response);
        commit("setSingle", response.data);
      },
      (error) => {
        commit("setFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getById({ dispatch, commit }, payload) {
    await companyService.getById(payload).then(
      (response) => {
        commit("setSingle", response.data);
      },
      (error) => {
        commit("setFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getAccount({ dispatch, commit }) {
    await companyService.getAccount().then(
      (response) => {
        commit("setSingle", response.data[0]);
      },
      (error) => {
        commit("setFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};

const mutations = {
  setSingle(state, data) {
    state.single = data;
  },

  setFailure(state, error) {
    state.status = { error: true, message: error.responseText };
    state.statusText = error.responseText;
  },
};

const getters = {};

export const company = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
